import { render, staticRenderFns } from "./ConferenceRoomBookingDelete.vue?vue&type=template&id=0f277d10&scoped=true"
import script from "./ConferenceRoomBookingDelete.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomBookingDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f277d10",
  null
  
)

export default component.exports